export interface SiteSearchResultRaw {
  identifiableuri: string;
  site_name: string;
  site_city?: string;
  site_state?: string;
  site_statecode?: string;
  site_address?: string;
  site_lattitude?: number;
  site_longitude?: number;
  site_relatedconditions?: string[];
  site_relatedcommunities?: string[];
  site_languages?: string[];
  site_status?: string;
  site_activestudiescount?: number;
  site_recruitingnowcount?: number;
  site_conditionscount?: number;
  site_recruitingtype?: string[];
  site_phase?: string[];
  site_url?: string;
  distance?: number;
}

export const SITE_FIELDS_TO_INCLUDE: string[] = [
  'identifiableuri',
  'site_name',
  'site_city',
  'site_state',
  'site_statecode',
  'site_address',
  'site_lattitude',
  'site_longitude',
  'site_relatedconditions',
  'site_relatedcommunities',
  'site_languages',
  'site_status',
  'site_activestudiescount',
  'site_recruitingnowcount',
  'site_conditionscount',
  'site_recruitingtype',
  'site_phase',
  'site_url',
  'distance',
];
